export default __webpack_public_path__ + "static/media/tvs-auto-logo.2e375bd5.png";